// src/utils/axiosInstance.js
import axios from "axios";
import config from "../config";

let accessToken = null;

export const setAccessToken = (token) => {
  accessToken = token;
};

const axiosInstance = axios.create({
  baseURL: config.API_BASE_URL,
});

axiosInstance.interceptors.request.use((request) => {
  if (accessToken) {
    request.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return request;
});

export default axiosInstance;